import ICoupon from "../interfaces/ICoupon"
import { get, post, patch, destroy } from "./utils/requests"

const validate = (code: string, camp_id: string, start_date: string, end_date: string): Promise<{ coupon: ICoupon }> =>
  post(`/api/coupons/validate`, { code, camp_id, start_date, end_date })

const fetchForCamp = (camp_id: string): Promise<{ coupons: Array<ICoupon> }> =>
  get(`/api/camps/${camp_id}/coupons`)  // TODO add camping styles id back in when we have the option to select in settings table

const create = (coupon: ICoupon, camp_id: string): Promise<{ coupon: ICoupon }> =>
  post(`/api/camps/${camp_id}/coupons`, { ...coupon, camp_id })

const update = (coupon: ICoupon): Promise<{ coupon: ICoupon }> =>
  patch(`/api/camps/${coupon.camp_id}/coupons/${coupon.id}`, coupon)

const remove = (coupon_id: string, camp_id: string): Promise<{ coupon: ICoupon }> =>
  destroy(`/api/camps/${camp_id}/coupons/${coupon_id}`)

const Coupons = {
  validate,
  fetchForCamp,
  create,
  update,
  remove,
}

export default Coupons
